<div class="content-header flex-row no-wrap">
  <div class="i-back-arrow" (click)="goBack()"></div>
  <h1 class="ellipsis">{{ room?.name | uppercase }}</h1>
</div>
<app-rgbw-light *ngIf="daliLightIsRgb(daliLight)" [daliRgbLightInput]="daliLight" [mode]="'live'"></app-rgbw-light>
<app-dimmable-dali-light *ngIf="daliLightIsDimmable(daliLight)" [daliLight]="daliLight" [mode]="'live'"></app-dimmable-dali-light>
<app-dimmable-light-group *ngIf="isDaliGroup(daliLight)" [daliLightsGroup]="daliLight" [mode]="'live'"></app-dimmable-light-group>
<app-dali-blind *ngIf="isDaliBlind(daliLight)" [daliBlind]="daliLight" [mode]="'live'"></app-dali-blind>
